// Module
var code = `<svc-action-button params="text: linkValueText, click: koClickLink, selected: isSelected, disabled: !isClickable, classes: linkSetButtonCssClasses, title: tooltip, iconName:iconName">
</svc-action-button>
<!-- ko if: !isReadOnly && showClear -->
<svc-action-button params="text: clearCaption, click: koClearLink, selected: isSelected, disabled: false, classes: linkClearButtonCssClasses, iconName:iconName">
</svc-action-button>
<!-- /ko -->`;
// Exports
export default code;